import { CashierManagementParams } from './../models/cashier-management-params.model';
import { HttpClient, HttpParams, HttpHeaders, HttpResponse  } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/core/_config/app.config';
import { CashierManagementDeposit } from '../models/cashier-management-deposit.model';
import { map } from 'rxjs/operators';
import { FileService } from 'src/app/services/file.service';

@Injectable({
    providedIn: 'root',
})
export class CashierManagementService {
    private API_URL = this.config.urlApi + this.config.versionApi;

    constructor(private http: HttpClient, private config: AppConfig, private fileService: FileService) {}

    private anyToHttpParams(obj: any): HttpParams {
        let params = new HttpParams();
        Object.keys(obj).forEach(function (item) {
            params = params.set(item, obj[item]);
        });
        return params;
    }

    public getCashierManagement(params: CashierManagementParams): Observable<any> {
        return this.http.get(`${this.API_URL}CashierManagement`, { params: this.anyToHttpParams(params) });
    }

    public GetCashierTable(params: CashierManagementParams): Observable<any> {
        return this.http.get(`${this.API_URL}CashierManagement/GetCashierTable`, 
        { params: this.anyToHttpParams(params) });

    }

    public getFinancialAccount(legalEntityId: string): Observable<any> {
        return this.http.get(`${this.API_URL}CashierManagement/FinancialAccount`, {
            params: { legalEntityId: legalEntityId },
        });
    }

    public depositCash(batchId: string, toDeposit: Array<CashierManagementDeposit>): Observable<any> {
        return this.http.post(`${this.API_URL}CashierManagement/DepositCash`, toDeposit, {
            params: { batchId: batchId },
        });
    }

    public canTransferBatch(): Observable<any> {
        return this.http.get(`${this.API_URL}CashierManagement/CanTransferBatch`);
    }

    public getCashiersToTransferByEntityId(entityId: string): Observable<any> {
        return this.http.get(`${this.API_URL}CashierManagement/GetCashiersToTransferByEntityId`, {
            params: { entityId: entityId },
        });
    }

    public transferBatchToCashier(batchId: string, cashierId: string): Observable<any> {
        return this.http.post(`${this.API_URL}CashierManagement/TransferBatchToCashier`, null, {
            params: { batchId: batchId, cashierId: cashierId },
        });
    }
}
